export interface CardFormState {
  number: string;
  name: string;
  expiry: string;
  cvc: string;
}

export const emptyCard: CardFormState = { number: '', name: '', expiry: '', cvc: '' };

/** Group digits into blocks of four for a card number input. */
export function formatCardNumber(value: string): string {
  const digits = value.replace(/[^0-9]/g, '').slice(0, 19);
  return digits.replace(/(.{4})/g, '$1 ').trim();
}

/** Format an expiry as MM/YY while typing. */
export function formatExpiry(value: string): string {
  const digits = value.replace(/[^0-9]/g, '').slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

function cardDigits(card: CardFormState): string {
  return card.number.replace(/[^0-9]/g, '');
}

export function isCardValid(card: CardFormState): boolean {
  return (
    cardDigits(card).length >= 13 &&
    card.name.trim().length >= 2 &&
    /^\d{2}\/\d{2}$/.test(card.expiry) &&
    /^\d{3,4}$/.test(card.cvc)
  );
}

export function cardLast4(card: CardFormState): string {
  return cardDigits(card).slice(-4);
}
